export const appLongArrowIcon = {
    data: `<svg viewBox="0 0 46 16" xmlns="http://www.w3.org/2000/svg"><path d="m3.8 7 5.6-5.6L8 0 0 8l8 8 1.4-1.4L3.8 9H46V7z" fill="currentColor" fill-rule="evenodd"/></svg>`,
    name: 'long-arrow' as const
};